import { Trash2 } from "lucide-react";
import TextInput from "../TextInput";
import Button from "../Button";
import Tooltip from "../../tooltip/Tooltip";
import "./_array-text.scss";

/**
 * Pure-UI list of text inputs with add/remove rows - replaces
 * `@simplifyhq/simplify-ui-reusables`' `FormInputArrayText`. Generalizes
 * the "Item 1/Item 2 + remove + '+ Add item'" pattern already hand-rolled
 * inline in `NewFieldModal` (its own dropdown/radio-option-list editor) -
 * same row shape, now shared. Remove uses the same `Button
 * variant="ghost-danger" iconOnly` pattern `TierTable` already uses for
 * per-row removal, rather than a bare clickable icon.
 */
const ArrayText = ({
  id,
  label,
  values = [],
  onChange,
  onBlur,
  placeholder,
  error,
  disabled = false,
  itemLabel = "Item",
  addLabel = "+ Add item",
  tooltip,
  className = "",
}) => {
  const updateItem = (index, value) => {
    const next = [...values];
    next[index] = value;
    onChange?.(next);
  };

  const removeItem = (index) => {
    onChange?.(values.filter((_, i) => i !== index));
  };

  const addItem = () => {
    onChange?.([...(values || []), ""]);
  };

  return (
    <Tooltip content={tooltip} disabled={!tooltip} className="array-text-tooltip-anchor">
      <div
        className={`array-text ${error ? "array-text--error" : ""} ${
          disabled ? "array-text--disabled" : ""
        } ${className}`}
      >
        {label && <span className="array-text__label">{label}</span>}
        {values.map((value, index) => (
          <div key={index} className="array-text__row">
            <TextInput
              id={id ? `${id}-${index}` : undefined}
              label={`${itemLabel} ${index + 1}`}
              value={value}
              placeholder={placeholder}
              onChange={(nextValue) => updateItem(index, nextValue)}
              onBlur={onBlur}
              disabled={disabled}
            />
            {!disabled && (
              <Button
                variant="ghost-danger"
                size="md"
                iconOnly
                icon={<Trash2 size={16} />}
                onClick={() => removeItem(index)}
                aria-label={`Remove ${itemLabel.toLowerCase()} ${index + 1}`}
              />
            )}
          </div>
        ))}
        {!disabled && (
          <Button variant="outlined" onClick={addItem}>
            {addLabel}
          </Button>
        )}
        {error && <p className="array-text__error">{error}</p>}
      </div>
    </Tooltip>
  );
};

export default ArrayText;
